import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import { useState } from "react";

const VerifyEmail = () => {
  const [resetOtpTime, setResetOtpTime] = useState<string>("");
  function HandleOtpSend() {
    setResetOtpTime("2 MN");
  }
  return (
    <Box>
      <Grid container direction={"column"} gap={3}>
        <Typography fontWeight={"bold"} variant="h6" color={"#004186"}>
          Enter OTP
        </Typography>
        <Typography>We have send OTP to your email id</Typography>
        <Box sx={{ display: "flex", gap: 6 }}>
          <TextField inputProps={{ min: 0, max: 1 }} type="numeric"></TextField>
          <TextField type="numeric"></TextField>
          <TextField type="numeric"></TextField>
          <TextField type="numeric"></TextField>
          <TextField type="numeric"></TextField>
          <TextField type="numeric"></TextField>
        </Box>
        <Button
          sx={{ backgroundColor: "#004186" }}
          fullWidth
          variant="contained"
        >
          Next
        </Button>
        <Button fullWidth onClick={HandleOtpSend} variant="outlined">
          Resent OTP
        </Button>
        <Typography color={"#004186"}>
          {`Resent OTP in ${resetOtpTime}`}
        </Typography>
      </Grid>
    </Box>
  );
};

export default VerifyEmail;
